import { Dialog, Tooltip } from "@mui/material";
import { useDialog } from "common";
import { cloneElement } from "react";
import EventForm from "./EventForm";
import { EventItem } from "./eventApi";
export interface CreateEventButtonProps {
  id?: any | "create";
  item?: EventItem;
  afterSave?: (newItem: any, isCreate: boolean) => void;
  children: any;
  title?: string;
}
export default function CreateEventButton({
  id,
  item,
  afterSave,
  children,
  title,
}: CreateEventButtonProps) {
  const [isOpen, setIsOpen, dialogProps] = useDialog();
  return (
    <>
      <Tooltip title={title}>
        <span>
          {cloneElement(children, { onClick: () => setIsOpen(true) })}
        </span>
      </Tooltip>
      <Dialog {...dialogProps} maxWidth="xl" fullWidth>
        <EventForm
          id={id as any}
          defaultValues={item}
          onClose={dialogProps.onClose}
          afterSave={(newItem, isCreate) => {
            afterSave && afterSave(newItem, isCreate);
            dialogProps.onClose && dialogProps.onClose({}, "backdropClick");
          }}
          hideBookingList
        />
      </Dialog>
    </>
  );
}
